import type { SubmarineCable } from '@/types';

// ---------------------------------------------------------------------------
// Submarine Cable Routes — Critical Global Internet Infrastructure
// Based on Telegeography Submarine Cable Map (public data)
// ---------------------------------------------------------------------------

export const SUBMARINE_CABLES: SubmarineCable[] = [
  {
    id: 'cable-1', name: 'FASTER (US-Japan)', owner: 'Google, SoftBank, China Telecom',
    status: 'active', capacity: '60 Tbps',
    path: [
      [-122.4, 37.8], [-130.0, 40.0], [-150.0, 35.0], [-170.0, 28.0],
      [170.0, 25.0], [150.0, 30.0], [140.0, 35.0], [139.7, 35.7],
    ],
  },
  {
    id: 'cable-2', name: 'Trans-Atlantic MAREA', owner: 'Microsoft, Facebook, Telefonica',
    status: 'active', capacity: '160 Tbps',
    path: [
      [-77.0, 38.9], [-65.0, 42.0], [-40.0, 48.0], [-20.0, 50.0],
      [-10.0, 51.5], [-8.5, 43.4],
    ],
  },
  {
    id: 'cable-3', name: 'SEA-ME-WE 3', owner: 'Consortium',
    status: 'active', capacity: '10 Tbps',
    path: [
      [103.8, 1.3], [100.5, 6.0], [99.5, 10.0], [80.5, 13.0],
      [74.0, 18.5], [57.5, 23.5], [50.0, 25.0], [43.0, 12.5],
      [39.0, 15.0], [32.5, 30.0], [32.3, 31.4],
      [24.0, 35.0], [15.0, 37.0], [10.0, 39.0], [5.0, 37.0],
      [-5.5, 36.0], [-8.0, 37.0], [-8.5, 40.0],
    ],
  },
  {
    id: 'cable-4', name: 'PEACE Cable', owner: 'China-led Consortium',
    status: 'active', capacity: '16 Tbps',
    path: [
      [121.5, 25.0], [117.0, 21.0], [110.0, 15.0], [103.8, 1.3],
      [99.0, 5.0], [80.0, 8.0], [63.0, 22.0], [57.5, 22.5],
      [50.0, 12.0], [43.0, 11.5], [41.5, 11.0], [39.0, 15.0],
      [33.0, 27.0], [29.0, 31.0], [28.0, 43.0], [36.5, 36.8],
    ],
  },
  {
    id: 'cable-5', name: 'Africa Coast to Europe (ACE)', owner: 'Orange, SFR, Portugal Telecom',
    status: 'active', capacity: '5.12 Tbps',
    path: [
      [-8.0, 37.0], [-17.0, 28.5], [-17.3, 14.7], [-16.0, 10.5],
      [-14.0, 6.0], [2.0, -1.0], [8.0, -4.0], [12.0, -6.0],
      [10.0, -8.5], [9.5, -15.0], [15.0, -22.0], [17.0, -29.0],
      [18.5, -34.5],
    ],
  },
  {
    id: 'cable-6', name: 'Asia-Pacific Gateway (APG)', owner: 'Consortium (Korea, Japan, China)',
    status: 'active', capacity: '54.8 Tbps',
    path: [
      [103.8, 1.3], [108.0, 14.0], [114.0, 21.0], [121.5, 25.0],
      [127.0, 35.0], [129.5, 35.1], [130.0, 33.0], [131.0, 30.0],
      [130.5, 26.0], [128.0, 24.5], [126.0, 35.1], [139.7, 35.7],
    ],
  },
  {
    id: 'cable-7', name: 'Baltic Sea Cables (threatened)', owner: 'Various',
    status: 'disrupted', capacity: '10 Tbps',
    path: [
      [10.0, 55.5], [12.5, 56.0], [15.0, 57.0], [18.5, 57.5],
      [22.0, 57.5], [24.5, 59.5], [25.0, 60.2], [25.5, 64.0], [28.0, 65.0],
    ],
  },
  {
    id: 'cable-8', name: 'Red Sea Cables (Houthi threat)', owner: 'Consortium',
    status: 'disrupted', capacity: '17 Tbps',
    path: [
      [32.5, 29.5], [34.5, 25.0], [38.0, 20.0], [42.0, 14.0],
      [43.5, 11.5], [45.5, 11.0], [49.0, 11.5], [51.5, 12.5],
    ],
  },
  {
    id: 'cable-9', name: 'Trans-Pacific Express (TPE)', owner: 'Consortium',
    status: 'active', capacity: '5.12 Tbps',
    path: [
      [-122.3, 37.5], [-140.0, 36.0], [-160.0, 30.0], [-170.0, 25.0],
      [170.0, 20.0], [155.0, 22.0], [141.0, 35.5],
      [129.5, 35.1], [129.0, 37.5], [129.0, 35.1],
    ],
  },
  {
    id: 'cable-10', name: 'EIG (Europe India Gateway)', owner: 'Bharti, Telecom Egypt',
    status: 'active', capacity: '3.84 Tbps',
    path: [
      [-5.5, 36.0], [3.0, 37.5], [10.0, 37.0], [19.0, 35.5],
      [25.0, 34.0], [32.5, 30.5], [32.3, 31.3], [34.0, 27.0],
      [39.0, 20.5], [43.5, 14.5], [51.5, 22.5], [57.5, 22.5],
      [63.0, 22.0], [67.0, 24.0], [72.8, 18.9],
    ],
  },
];

export function fetchSubmarineCables(): SubmarineCable[] {
  return SUBMARINE_CABLES;
}
